import { createClient } from 'contentful';
import localConfig from 'mode-shared/configs/config';

export const contentfulClient = createClient({
  space: localConfig.contentfulSpace,
  accessToken: localConfig.contentfulToken,
  host: localConfig.contentfulHost,
});
